import { Directive, ElementRef, Renderer, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[appEstadoCobro]'
})
export class EstadoCobroDirective implements OnChanges{

  constructor(private _element: ElementRef, private _renderer: Renderer) { }

  @Input() appEstadoCobro: number;

  ngOnChanges(): void {
    switch(this.appEstadoCobro){
      case 1:
        this._renderer.setElementClass(this._element.nativeElement, 'green-600', true);
        break;
      case 2:
        this._renderer.setElementClass(this._element.nativeElement, 'primary-400', true);
        break;
      case 3:
        this._renderer.setElementClass(this._element.nativeElement, 'accent-800', true);
        break;
      case 4:
        this._renderer.setElementClass(this._element.nativeElement, 'yellow-600', true);
        break;
      case 6:
        this._renderer.setElementClass(this._element.nativeElement, 'indigo-300', true);
        break;
      case 7:
        this._renderer.setElementClass(this._element.nativeElement, 'teal', true);
        break;
      case 8:
        this._renderer.setElementClass(this._element.nativeElement, 'green-800', true);
        break;
      case 9:
        this._renderer.setElementClass(this._element.nativeElement, 'green-400', true);
        break;
      case 10:
        this._renderer.setElementClass(this._element.nativeElement, 'warn-700', true);
        break;
      case 11:
        this._renderer.setElementClass(this._element.nativeElement, 'orange-400', true);
        break;
      case 12:
        this._renderer.setElementClass(this._element.nativeElement, 'indigo', true);
        break;
      case 13:
        this._renderer.setElementClass(this._element.nativeElement, 'light-green-700', true);
        break;
      case 0:
        this._renderer.setElementClass(this._element.nativeElement, 'warn-600', true);
        break;
    }
  }

}
